<script setup>
import { ref, onMounted } from 'vue';
import LoginForm from '@components/loginForm/loginForm.vue';
import ModalSuccess from '@components/modal/modal-success.vue';
import ModalError from '@components/modal/modal-error.vue';
import { __, requestAccountSession } from '@/utils'
import AccountBadge from '@components/accountBadge/accountBadge.vue';

const urlParams = new URLSearchParams(window.location.search);
const hasLogin = urlParams.get('login-open');
const showModal = hasLogin === 'true' ? true : false;

const showLogin = ref(showModal);
const showSuccess = ref(false);
const showError = ref(false);
const details = ref({});
const isLogged = ref(false);

const handleOpen = () => {
    showLogin.value = true;
    const burger = document.querySelector('#burger-button');

    if(burger && window.windowWidth < 1024) {
        burger.click();
    }
}

const handleSuccess= () => {
    showLogin.value = false;
    showSuccess.value = true;
    setTimeout(() => {
        window.location = '/account';
    }, 3000);
}

const handleRetry = () => {
    showError.value = false;
    showLogin.value = true;
}

const handleError = () => {
    showError.value = true;
    showLogin.value = false;
}

const fetchAccountSession = async () => {
    let [data, error] = await requestAccountSession();

    if(error) {
        console.error(error);
    } else {
        if(data) {
            details.value = data.data ?? {};
            isLogged.value = details.value?.id ? true : false;
        }
    }
};

onMounted(() => {
    fetchAccountSession();
});
</script>

<template>
    <AccountBadge v-if="isLogged" :data="details" />
    <button v-if="!isLogged" type="button" class="btn btn--login" @click="handleOpen">{{ __('Customer login') }}</button>

    <LoginForm v-if="showLogin" :isActive="showLogin" @close="showLogin = false" @success="handleSuccess" @error="handleError" />
    <ModalSuccess v-if="showSuccess" @close="showSuccess = false" />
    <ModalError v-if="showError" @close="showError = false" @retry="handleRetry" />
</template>